import { render, staticRenderFns } from "./catalogue.vue?vue&type=template&id=aeb8d75e&scoped=true&"
import script from "./catalogue.vue?vue&type=script&lang=js&"
export * from "./catalogue.vue?vue&type=script&lang=js&"
import style0 from "./catalogue.vue?vue&type=style&index=0&id=aeb8d75e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb8d75e",
  null
  
)

export default component.exports